// ----------------------------------------------------------------
// <copyright company="Microsoft Corporation">
//     Copyright (c) Microsoft Corporation. All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import * as React from 'react';
import { useTranslation } from 'react-i18next';
import {
    TooltipHost,
    Icon
} from 'office-ui-fabric-react';
import Collapsible from './../Collapsible';

import RenderAccessoryBody from './RenderAccessoryBody';

import Styles from './styles.module.scss';

interface Data {
    name: string;
    sku: string;
    serialNumber: string;
}

interface PropsType {
    data: Data[];
    isLoading: boolean;
    isEligible?: boolean;
    eligibilityToolTip?: string;
    selected: Data[];
    onSelect: (selected: Data[]) => void;
}

export default function AccessoryListItem(props: PropsType): JSX.Element {
    const { t } = useTranslation();
    return (
        <Collapsible
            isOpen={!!props.selected.length}
            colorOnOpen={'white'}
            colorOnClose={'nobel'}
            chevronColor={'black'}
            header={HeaderRender(props.eligibilityToolTip, props.isEligible)}
            tableName={t('accessories')}
        >
            <div className={Styles.body}>
                {RenderAccessoryBody({
                    isEligible: props.isEligible,
                    data: props.data,
                    isLoading: props.isLoading,
                    selected: props.selected,
                    onSelect: props.onSelect,
                })}
            </div>
        </Collapsible>
    );
}

function HeaderRender(tooltipTitle: string = 'accessories', isEligible?: boolean): JSX.Element {
    const { t } = useTranslation();
    return (
        <div className={Styles.header}>
            <div className={Styles.headerText} id="accessories_parent">
                {t('accessories')}
                {
                    !isEligible ?
                        (<TooltipHost
                            aria-label={t('order_cannot_be_created', { reason: t(tooltipTitle) })}
                            calloutProps={{ gapSpace: 0 }}
                            content={t('order_cannot_be_created', { reason: t(tooltipTitle) })}
                            id="accessories_child"
                        > <Icon
                                className={Styles.warningIcon}
                                iconName="warning"
                                aria-label={t('order_cannot_be_created', { reason: t(tooltipTitle) })}
                            />
                        </TooltipHost>
                        )
                        : null
                }
            </div>
        </div>
    );
}
